<template>
  <div class="legacy-redirect md-layout text-center">
    <div class="md-layout-item md-size-100" />
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 legacy-card-wrap">
      <div class="legacy-card">
        <h2 class="legacy-title">Chat đã chuyển sang domain mới</h2>
        <p class="legacy-lead">
          Trang <strong>social.chatteam.asia</strong> chỉ còn dùng để hướng dẫn chuyển đổi.
          Vui lòng truy cập đúng địa chỉ chat của chi nhánh hoặc hub bên dưới.
        </p>
        <div class="legacy-actions">
          <a
            v-if="hubUrl"
            :href="hubUrl"
            class="legacy-btn"
            rel="noopener noreferrer"
          >
            Mở Chat Hub
          </a>
        </div>
        <p v-if="hubUrl" class="legacy-url">{{ hubUrl }}</p>
        <p class="legacy-hint">
          Nếu bạn thuộc chi nhánh cụ thể, hãy dùng link do quản trị viên cung cấp
          (dạng <code>social.{ten-chi-nhanh}</code>).
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { loadSsoConfig } from "../../../helper/sso";

export default {
  name: "LegacySocialRedirect",

  data() {
    return {
      hubUrl: "",
    };
  },

  async created() {
    const cfg = await loadSsoConfig(true);
    const hub = cfg && cfg.platform && cfg.platform.hub_social_url;
    this.hubUrl = hub && String(hub).trim() ? String(hub).trim() : "";
  },
};
</script>

<style scoped>
.legacy-redirect {
  min-height: 60vh;
  align-items: center;
}
.legacy-card-wrap {
  margin: 0 auto;
}
.legacy-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 2rem 1.75rem;
  text-align: left;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}
.legacy-title {
  margin: 0 0 0.75rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
}
.legacy-lead {
  margin: 0 0 1rem;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #475569;
}
.legacy-actions {
  margin-top: 0.5rem;
}
.legacy-btn {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.65rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #fff !important;
  text-decoration: none !important;
  background: linear-gradient(90deg, #6366f1, #4f46e5);
}
.legacy-url {
  margin: 1rem 0 0;
  font-size: 0.75rem;
  word-break: break-all;
  color: #94a3b8;
}
.legacy-hint {
  margin: 1.25rem 0 0;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.45;
}
.legacy-hint code {
  font-size: 0.75rem;
  background: #f1f5f9;
  padding: 0.1rem 0.35rem;
  border-radius: 4px;
}
</style>
